import { FormAutocomplete } from "@components/FormAutocomplete";
import styled from "@emotion/styled";

export const StyledAutocomplete = styled(FormAutocomplete)`
  & .MuiAutocomplete-popupIndicator {
    transform: none;
  }
`;
